import { normalizeVoiceText, removeVoicePhrase } from './matchVoiceSearchCity';

export type AssistantPriceSort = 'priceAsc' | 'priceDesc';

type PriceSortPhrase = { phrase: string; sort: AssistantPriceSort };

const PRICE_SORT_PHRASES: PriceSortPhrase[] = ([
  { phrase: 'מהזול ליקר', sort: 'priceAsc' },
  { phrase: 'מהזול אל היקר', sort: 'priceAsc' },
  { phrase: 'מהיקר לזול', sort: 'priceDesc' },
  { phrase: 'מהיקר אל הזול', sort: 'priceDesc' },
  { phrase: 'הכי זול', sort: 'priceAsc' },
  { phrase: 'הכי זולה', sort: 'priceAsc' },
  { phrase: 'הכי זולים', sort: 'priceAsc' },
  { phrase: 'הכי זולות', sort: 'priceAsc' },
  { phrase: 'הזול ביותר', sort: 'priceAsc' },
  { phrase: 'הזולה ביותר', sort: 'priceAsc' },
  { phrase: 'הזולים ביותר', sort: 'priceAsc' },
  { phrase: 'הזולות ביותר', sort: 'priceAsc' },
  { phrase: 'הכי משתלם', sort: 'priceAsc' },
  { phrase: 'הכי משתלמת', sort: 'priceAsc' },
  { phrase: 'המחיר הכי נמוך', sort: 'priceAsc' },
  { phrase: 'במחיר הכי נמוך', sort: 'priceAsc' },
  { phrase: 'המחיר הנמוך ביותר', sort: 'priceAsc' },
  { phrase: 'במחיר הנמוך ביותר', sort: 'priceAsc' },
  { phrase: 'הכי יקר', sort: 'priceDesc' },
  { phrase: 'הכי יקרה', sort: 'priceDesc' },
  { phrase: 'הכי יקרים', sort: 'priceDesc' },
  { phrase: 'הכי יקרות', sort: 'priceDesc' },
  { phrase: 'היקר ביותר', sort: 'priceDesc' },
  { phrase: 'היקרה ביותר', sort: 'priceDesc' },
  { phrase: 'היקרים ביותר', sort: 'priceDesc' },
  { phrase: 'היקרות ביותר', sort: 'priceDesc' },
  { phrase: 'המחיר הכי גבוה', sort: 'priceDesc' },
  { phrase: 'במחיר הכי גבוה', sort: 'priceDesc' },
  { phrase: 'המחיר הגבוה ביותר', sort: 'priceDesc' },
  { phrase: 'לפי מחיר', sort: 'priceAsc' },
  { phrase: 'least expensive', sort: 'priceAsc' },
  { phrase: 'lowest price', sort: 'priceAsc' },
  { phrase: 'price low to high', sort: 'priceAsc' },
  { phrase: 'low to high', sort: 'priceAsc' },
  { phrase: 'sort by price', sort: 'priceAsc' },
  { phrase: 'by price', sort: 'priceAsc' },
  { phrase: 'cheapest', sort: 'priceAsc' },
  { phrase: 'most expensive', sort: 'priceDesc' },
  { phrase: 'highest price', sort: 'priceDesc' },
  { phrase: 'price high to low', sort: 'priceDesc' },
  { phrase: 'high to low', sort: 'priceDesc' },
  { phrase: 'priciest', sort: 'priceDesc' },
] as PriceSortPhrase[]).sort((a, b) => b.phrase.length - a.phrase.length);

/** Words left around a ranking request that are not a place or venue name. */
const PRICE_SORT_FILLERS = [
  'מבין שניהם',
  'מבין שתיהן',
  'מבין התוצאות',
  'מתוך התוצאות',
  'מבין אלה',
  'מביניהם',
  'מביניהן',
  'מהתוצאות',
  'מאלה',
  'מהם',
  'האפשרות',
  'האופציה',
  'המקום',
  'הנכס',
  'החלל',
  'תמיין',
  'מיין',
  'סדר',
  'תסדר',
  'among them',
  'among these',
  'of them',
  'of these',
  'from these',
  'between them',
  'the one',
  'option',
  'one',
  'sort',
].sort((a, b) => b.length - a.length);

/** “הכי זול”, “cheapest”, “מהיקר לזול” → list order; the phrase and its filler words are removed. */
export function parseAssistantPriceSort(text: string): {
  sort: AssistantPriceSort | null;
  remainder: string;
} {
  const hay = normalizeVoiceText(text);
  for (const entry of PRICE_SORT_PHRASES) {
    const next = removeVoicePhrase(hay, entry.phrase);
    if (next === hay) {
      continue;
    }
    let remainder = next;
    for (const filler of PRICE_SORT_FILLERS) {
      remainder = removeVoicePhrase(remainder, filler);
    }
    return { sort: entry.sort, remainder: remainder.replace(/\s+/g, ' ').trim() };
  }
  return { sort: null, remainder: hay };
}
